<template>
  <b-row>
    <b-col cols="12" class="mt-3 mb-5">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left">
            <span class="mb-0 h3 ml-2">商城設定</span>
          </div>
        </template>
        <b-row class="mb-5">
          <b-col cols="6" offset="3">
            <b-form @submit.prevent="onSubmit">
              <b-form-group label-for="name-input" class="mb-3" :state="Boolean(name.length)">
                <template slot="label">
                  <span class="text-danger">*</span>商城名稱
                </template>
                <b-form-input id="name-input" v-model="name" :state="Boolean(name.length)"></b-form-input>
              </b-form-group>
              <b-form-group id="address-input-group" label="聯絡地址" label-for="address-input" class="mb-3">
                <b-form-input id="address-input" v-model="address" :disabled="busy"></b-form-input>
              </b-form-group>
              <b-form-group id="tel-input-group" label="服務專線" label-for="tel-input" class="mb-3">
                <b-form-input id="tel-input" v-model="tel" :disabled="busy"></b-form-input>
              </b-form-group>
              <b-form-group id="email-input-group" label="服務信箱" label-for="email-input" class="mb-3">
                <b-form-input id="email-input" v-model="email" :disabled="busy"></b-form-input>
              </b-form-group>
              <b-form-group id="serviceTime-input-group" label="服務時間" label-for="serviceTime-input" class="mb-3">
                <b-form-input id="serviceTime-input" v-model="serviceTime" :disabled="busy"></b-form-input>
              </b-form-group>
              <label for="timeout-selector">
                <span class="text-danger">*</span>超時提示
              </label>
              <b-form-select :state="Boolean(selectedTimeoutDays)" id="timeout-selector" v-model="selectedTimeoutDays" required>
                <b-form-select-option :value="null">請選擇天數</b-form-select-option>
                <b-form-select-option v-for="n in 10" :key="n" :value="n">
                  尚未取貨超過 {{n}} 天，將自動發送通知信
                </b-form-select-option>
              </b-form-select>
              <b-button class="float-right mt-3" variant="primary" type="submit">送出</b-button>
            </b-form>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: 'control-glob',
  data () {
    return {
      name: '',
      address: '',
      tel: '',
      email: '',
      serviceTime: '',
      selectedTimeoutDays: null,
      busy: false
    }
  },
  methods: {
    async start () {
      this.busy = true
      try {
        const { data: {
          name,
          address,
          tel,
          email,
          service_time: serviceTime,
          deliver_notify_timeout_day: timeoutDays
        } } = await this.$api.getConfig()
        this.name = name
        this.address = address
        this.tel = tel
        this.email = email
        this.serviceTime = serviceTime
        this.selectedTimeoutDays = timeoutDays
      } catch (err) {
        console.log(err)
        this.showErrorBox()
      }
      this.busy = false
    },
    async onSubmit () {
      if (this.busy) return
      this.busy = true
      try {
        await this.$api.putConfig({
          name: this.name,
          address: this.address,
          tel: this.tel,
          email: this.email,
          service_time: this.serviceTime,
          deliver_notify_timeout_day: this.selectedTimeoutDays
        })
        this.showSuccessBox()
      } catch (err) {
        console.log(err)
        this.showErrorBox()
      }
      this.busy = false
      this.start()
    },
    showSuccessBox () {
      this.$bvToast.toast('資料已更新。請重新整理。', {
        title: '操作成功',
        variant: 'success'
      })
    },
    showErrorBox () {
      this.$bvToast.toast('連線錯誤，資料尚未更新。', {
        title: '操作失敗',
        variant: 'danger'
      })
    }
  },
  mounted () {
    this.start()
  }
}
</script>